import { Box, Typography } from '@mui/material';
import {
  ControlledSelect,
  ControlledTextField
} from 'components/shared/ControlledFields';
import { PlanUnitDetails } from 'components/types';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'utils/date';

export interface PlanUnitEditableFieldParams {
  isEditMode: boolean;
  control: Control<PlanUnitDetails, unknown>;
  planUnitDetails: PlanUnitDetails | null | undefined;
  objectKey: string;
  langKey?: string;
  fieldType?: 'text' | 'date' | 'select' | 'textarea';
  optionsBuilder?: () => { value: string; label: string }[];
}

const PlanUnitEditableField = ({
  isEditMode,
  control,
  planUnitDetails,
  objectKey,
  langKey = objectKey,
  fieldType = 'text',
  optionsBuilder
}: PlanUnitEditableFieldParams) => {
  const { t } = useTranslation('common', { keyPrefix: 'costCenters.details' });

  return (
    <Box display="flex" minHeight="40px">
      <Box width="30%" mt={1.3}>
        <Typography>{t(langKey)}</Typography>
      </Box>

      {isEditMode ? (
        <Box flexGrow={1} pr={15}>
          {fieldType == 'text' && (
            <ControlledTextField control={control} name={objectKey} />
          )}
          {fieldType == 'textarea' && (
            <ControlledTextField
              multiline={true}
              minRows={3}
              control={control}
              name={objectKey}
            />
          )}
          {fieldType == 'select' && !!optionsBuilder && (
            <ControlledSelect
              label=""
              control={control}
              name={objectKey}
              options={optionsBuilder()}
            />
          )}
          {fieldType == 'date' && <>{/*Not yet supported*/}</>}
        </Box>
      ) : (
        <Box width="30%" mt={1.4}>
          {!planUnitDetails || !planUnitDetails[objectKey] ? (
            '-'
          ) : (
            <>
              {fieldType != 'date'
                ? planUnitDetails[objectKey]
                : formatDate(planUnitDetails[objectKey])}
            </>
          )}
        </Box>
      )}
    </Box>
  );
};

export default PlanUnitEditableField;
